module.exports = __webpack_public_path__ + "img/coupon_tips.880d1e3f.png";